import {useStepper} from "@/components/StepperProvider";
import {useState} from "react";
import {Label} from "@/components/ui/label";
import {Input} from "@/components/ui/input";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/components/ui/select";
import {StepperNavigation} from "@/components/StepperNavigation";
import {Separator} from "@/components/ui/separator";
import { useFeature } from "@/hooks/use-feature";

const GettingStartedStep = () => {
    const { formData, updateFormData } = useStepper();
    const { limits } = useFeature();
    const [title, setTitle] = useState(formData.title || '');
    const [ageGroup, setAgeGroup] = useState(formData.ageGroup || '');
    const [artStyle, setArtStyle] = useState(formData.artStyle || '');

    const handleNext = () => {
        updateFormData({ title, ageGroup, artStyle });
    };

    return (
        <div className="space-y-6">
            <div className="space-y-2 ">
                <Label htmlFor="title">Book Title*</Label>
                <Input
                    id="title"
                    placeholder="Enter a title for your book"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
            </div>

            <div className="space-y-2">
                <Label htmlFor="age-group">Target Age Group*</Label>
                <Select value={ageGroup} onValueChange={setAgeGroup}>
                    <SelectTrigger id="age-group" aria-label="Select age group">
                        <SelectValue placeholder="Select age group" />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="0-3">1-3 years</SelectItem>
                        <SelectItem value="3-5">3-5 years</SelectItem>
                        <SelectItem value="5-8">5-8 years</SelectItem>
                        <SelectItem value="8+">8 years and up</SelectItem>
                    </SelectContent>
                </Select>
            </div>

            <div className="space-y-2">
                <Label htmlFor="art-style">Art Style*</Label>
                <Select value={artStyle} onValueChange={setArtStyle}>
                    <SelectTrigger id="art-style" aria-label="Select art style">
                        <SelectValue placeholder="Choose an art style" />
                    </SelectTrigger>
                    <SelectContent>
                    {[...limits?.allArtStyles || []].sort((a, b) => {
                        const aAvailable = limits?.artStyles?.includes(a);
                        const bAvailable = limits?.artStyles?.includes(b);
                        if (aAvailable === bAvailable) return 0;
                        return aAvailable ? -1 : 1;
                    }).map((style) => {
                        const isDisabled = !limits?.artStyles?.includes(style);
                        return (
                            <SelectItem
                                key={style}
                                value={style}
                                disabled={isDisabled}
                                className="flex items-center justify-between"
                            >
                                {style.replace(/\b\w/g, char => char.toUpperCase())}
                                {isDisabled && (
                                    <span className="ml-2 text-xs text-muted-foreground">
                                        {limits?.plan === "FAMILY" && "Family Pro Only"}
                                        {limits?.plan === "FREE" && "Premium Only"}
                                    </span>
                                )}
                            </SelectItem>
                        );
                    })}
                    </SelectContent>
                </Select>
            </div>

            <Separator />
            <StepperNavigation
                onNext={handleNext}
                nextDisabled={!ageGroup || !artStyle || !title}
            />
        </div>
    );
};

export default GettingStartedStep;
